var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.925556 2.55828C0.365556 2.80768 0 3.36883 0 3.98453V7.64756C0 11.9731 2.98667 16.018 7 17C11.0133 16.018 14 11.9731 14 7.64756V3.98453C14 3.36883 13.6344 2.80768 13.0744 2.55828L7.63 0.134441C7.22556 -0.0448138 6.76667 -0.0448138 6.37 0.134441L0.925556 2.55828ZM7 4.53009C7.42778 4.53009 7.77778 4.8808 7.77778 5.30946C7.77778 5.73811 7.42778 6.08883 7 6.08883C6.57222 6.08883 6.22222 5.73811 6.22222 5.30946C6.22222 4.8808 6.57222 4.53009 7 4.53009ZM7 7.64756C7.42778 7.64756 7.77778 7.99828 7.77778 8.42693V11.5444C7.77778 11.9731 7.42778 12.3238 7 12.3238C6.57222 12.3238 6.22222 11.9731 6.22222 11.5444V8.42693C6.22222 7.99828 6.57222 7.64756 7 7.64756Z",
    fill: "#A1A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacyPolicy.be513ff6dbeec091b01d04932a5b0e1c.svg";
export { ForwardRef as ReactComponent };